import SectionHeading from '@/pages/home/components/SectionHeading';
import { hotRank, updateFeed } from '@/mocks/home';

const trendIcon: Record<string, string> = {
  up: 'ri-arrow-up-line',
  down: 'ri-arrow-down-line',
  flat: 'ri-subtract-line',
};

const trendColor: Record<string, string> = {
  up: 'text-primary-500',
  down: 'text-secondary-500',
  flat: 'text-foreground-400',
};

export default function UpdateFeedSection() {
  return (
    <section id="feed" className="scroll-mt-20 bg-background-100 py-16 md:py-20">
      <div className="mx-auto w-full max-w-[1280px] px-4 md:px-8 xl:px-10">
        <SectionHeading
          eyebrow="Live Feed"
          title="爆料速递"
          desc="档案的新增、更正与信源补充都会在这里按时间滚动展示，想看某位人物的最新进展，直接从这里进入对应档案即可。"
        />

        <div className="mt-10 grid grid-cols-1 gap-6 lg:grid-cols-12 lg:gap-8">
          <div className="lg:col-span-8">
            <div className="rounded-lg border border-background-200 bg-background-50 px-3 md:px-5">
              {updateFeed.map((item) => (
                <a
                  key={item.title}
                  href="#archive"
                  className="group flex cursor-pointer gap-4 border-b border-background-200/80 py-4 last:border-b-0"
                >
                  <div className="hidden w-24 shrink-0 flex-col items-start gap-1.5 sm:flex">
                    <span className="font-label text-xs text-foreground-500">{item.time}</span>
                    <span className="rounded-sm bg-primary-100 px-1.5 py-0.5 font-label text-[11px] text-primary-700">
                      {item.tag}
                    </span>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-sm font-medium leading-snug text-foreground-900 transition-colors group-hover:text-primary-600 md:text-[15px]">
                      {item.title}
                    </h3>
                    <p className="mt-1.5 text-xs leading-relaxed text-foreground-600 md:text-[13px]">
                      {item.desc}
                    </p>
                    <span className="mt-2 inline-flex items-center gap-2 font-label text-[11px] text-foreground-500 sm:hidden">
                      {item.time}
                      <span className="rounded-sm bg-primary-100 px-1.5 py-0.5 text-primary-700">
                        {item.tag}
                      </span>
                    </span>
                  </div>
                  <span className="hidden shrink-0 items-center gap-1.5 self-center font-label text-xs text-foreground-500 sm:flex">
                    <span className="flex h-4 w-4 items-center justify-center">
                      <i className="ri-links-line text-sm" />
                    </span>
                    {item.sources}
                  </span>
                </a>
              ))}
            </div>
          </div>

          <aside className="lg:col-span-4">
            <div className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-6 lg:sticky lg:top-24">
              <div className="flex items-center gap-2">
                <span className="flex h-5 w-5 items-center justify-center text-primary-500">
                  <i className="ri-fire-fill text-base" />
                </span>
                <h3 className="font-heading text-base font-bold text-foreground-950">
                  热议人物榜
                </h3>
              </div>
              <p className="mt-2 font-label text-xs text-foreground-500">按近 24 小时讨论热度</p>
              <ul className="mt-4">
                {hotRank.map((person) => (
                  <li key={person.name}>
                    <a
                      href="#archive"
                      className="group flex cursor-pointer items-center gap-3 border-b border-background-200/80 py-3 last:border-b-0"
                    >
                      <span
                        className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-sm font-label text-xs font-medium ${
                          person.rank <= 3
                            ? 'bg-accent-100 text-accent-900'
                            : 'bg-background-200 text-foreground-600'
                        }`}
                      >
                        {person.rank}
                      </span>
                      <span className="flex-1 font-label text-sm text-foreground-800 transition-colors group-hover:text-primary-600">
                        {person.name}
                      </span>
                      <span className="font-label text-xs text-foreground-500">{person.heat}</span>
                      <span
                        className={`flex h-4 w-4 items-center justify-center ${trendColor[person.trend]}`}
                      >
                        <i className={`${trendIcon[person.trend]} text-sm`} />
                      </span>
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}